<template>
  <m-card-item
    v-if="props.provisionedUser.deactivatedAt === null"
    icon="archive"
    :tooltip="$t('userListCard.disableUserProvisioningTooltip')"
    tooltip-placement="left"
    hide-border
    @click="confirmDisable"
  >
    {{ t('userProvisioningStatusBadge.disableProvisioning') }}
  </m-card-item>
  <m-card-item
    v-if="props.provisionedUser.deactivatedAt !== null"
    icon="api"
    hide-border
    @click="enable"
  >
    {{ t('userProvisioningStatusBadge.enableProvisioning') }}
  </m-card-item>
</template>

<script setup>
import useConfirmDialog from '@/composables/confirm-dialog';
import useRepo from '@/nebula/repo';
import useSnackBar from '@/composables/snackbar';
import { provisionedUser as provisionedUserConfig } from 'shared/api/query/configs.json';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  provisionedUser: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();
const repo = useRepo(provisionedUserConfig.model);
const snackbar = useSnackBar();
const confirmDialog = useConfirmDialog();

const confirmDisable = () => {
  const disableMethod = () => repo.updateSingle({ uid: props.provisionedUser.uid, deactivatedAt: new Date() }).then(() => {
    snackbar.success(t('success.paused'));
  }).catch(() => {
    snackbar.error();
  });

  confirmDialog.confirm({
    title: t('userList.disableUserProvisioningTitle'),
    okText: t('general.yesPause'),
    okType: 'danger',
    cancelText: t('general.cancel'),
    maskClosable: true,
    onOk() {
      disableMethod();
    },
  });
};

const enable = () => {
  repo.updateSingle({ uid: props.provisionedUser.uid, deactivatedAt: null }).then(() => {
    snackbar.success(t('success.reactivated'));
  }).catch(() => {
    snackbar.error(t('error.default'));
  });
};
</script>
